<template>
  <path
    d="M20 18.0002C21.1 18.0002 22 17.1002 22 16.0002V6.00018C22 4.90018 21.1 4.00018 20 4.00018H4C2.9 4.00018 2 4.90018 2 6.00018V16.0002C2 17.1002 2.9 18.0002 4 18.0002H1C0.45 18.0002 0 18.4502 0 19.0002C0 19.5502 0.45 20.0002 1 20.0002H23C23.55 20.0002 24 19.5502 24 19.0002C24 18.4502 23.55 18.0002 23 18.0002H20ZM5 6.00018H19C19.55 6.00018 20 6.45018 20 7.00018V15.0002C20 15.5502 19.55 16.0002 19 16.0002H5C4.45 16.0002 4 15.5502 4 15.0002V7.00018C4 6.45018 4.45 6.00018 5 6.00018Z"
  />
</template>
